__turbopack_context__.v({
  "banner": "CookieConsent-module__QbGkGW__banner",
  "button": "CookieConsent-module__QbGkGW__button",
  "link": "CookieConsent-module__QbGkGW__link",
  "text": "CookieConsent-module__QbGkGW__text",
});
